import './home.css';
import React, { createContext, useEffect } from 'react';
import { motion } from 'framer-motion';
import wearebiam from '../../assets/images/wearebiam.svg';
import homebgvideo1 from '../../assets/videos/bghomeone.mp4';
import dettypeople from '../../assets/videos/dettypeople.mp4';
import homebgvideo3 from '../../assets/videos/bghomethree.mp4';
import homebgvideo4 from '../../assets/videos/bghomefour.mp4';
import phaphanedj from '../../assets/videos/phaphanedj.mp4';
import VideoSection from '../../components/VideoSection/VideoSection';
import Footer from "../../components/Footer/Footer";
import { Helmet } from 'react-helmet';

export const LoadingContext = createContext();

function Home() {

  useEffect(() => {
    const sections = document.querySelectorAll(".section");

    const handleScroll = () => {
      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.75) {
          section.classList.add("opacity-100", "translate-y-0", "scale-100", "rotate-0");
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Exécuter une première fois

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const fadeInUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: 'easeOut' } },
  };

  return (

    <>
      <Helmet>
        <title>WEAREBIAM | HOME</title>
        <meta name="description" content="WE ARE A creative PRODUCTION powerhouse that pushes boundaries, inspires, and empowers a generation of creators Through innovative thinking. WE transforms cultural and creative values into powerful business strategies." />

        {/* Open Graph */}
        <meta property="og:title" content="WEAREBIAM | HOME" />
        <meta property="og:description" content="WE ARE A creative PRODUCTION powerhouse that pushes boundaries, inspires, and empowers a generation of creators Through innovative thinking. WE transforms cultural and creative values into powerful business strategies." />
        <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/werebiam.firebasestorage.app/o/assets%2Fwebcover_bw.png?alt=media&token=f3686ce5-b347-4f99-8b23-0f52d461675c" />
        <meta property="og:url" content="https://wearebiam.com/" />
        <meta property="og:type" content="website" />

      </Helmet>

      <div className="scroll-container w-full h-screen overflow-y-auto snap-y snap-mandatory bg-black">
        <div>
          {/* Section 1 */}
          <VideoSection videoSrc={homebgvideo1}>
            <motion.img
              className="lg:w-[650px] w-[320px] mb-2.5"
              src={wearebiam}
              alt=""
              variants={fadeInUp}
              initial="hidden"
              animate="visible"
            />
            <motion.p
              className="text-white text-[12px] lg:text-[16px] lg:w-[650px] w-[320px] text-center"
              variants={fadeInUp}
              initial="hidden"
              animate="visible"
              transition={{ delay: 0.2 }}
            >
              THE NEXTGEN CREATIVE POWERHOUSE
            </motion.p>
          </VideoSection>

          <motion.div
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <VideoSection videoSrc={dettypeople} />
          </motion.div>

          {/* Section 2 */}
          <motion.div
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <VideoSection videoSrc={homebgvideo4} />
          </motion.div>

          {/* Section 3 */}
          <motion.div
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <VideoSection videoSrc={phaphanedj} />
          </motion.div>

          {/* Section 4 */}
          <motion.div
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <VideoSection videoSrc={homebgvideo3} />
          </motion.div>
        </div>

        <Footer />
      </div>
    </>
  );
}

export default Home;